<template>
    <div>
        <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
            <form @submit.prevent="form.post(action)">
                <div class="px-4 py-5 bg-white sm:p-6 shadow-xl rounded-tl-md rounded-tr-md">
                    <div>
                        <jet-label for="name" value="Name"/>
                        <jet-input id="name" class="mt-1 block w-full" type="text" v-model="form.name"/>
                        <div v-if="form.errors.name" class="mt-2 text-sm text-red-600">{{ form.errors.name }}</div>
                    </div>
                </div>

                <div class="flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6 shadow-xl sm:rounded-bl-md sm:rounded-br-md">
                    <inertia-link class="rounded-md border border-transparent bg-yellow-400 hover:bg-yellow-300 transition inline-flex items-center px-4 py-2 mr-2 text-xs text-white uppercase tracking-widest font-semibold"
                                  :href="route('verticals.index')">Cancel
                    </inertia-link>
                    <jet-button :disabled="form.processing">{{ button }}</jet-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout';
    import {useForm} from '@inertiajs/inertia-vue3';
    import JetButton from '@/Jetstream/Button';
    import JetInput from '@/Jetstream/Input';
    import JetLabel from '@/Jetstream/Label';

    export default {
        props: ['vertical', 'action', 'method','button'],

        components: {
            AppLayout,
            JetButton,
            JetInput,
            JetLabel,
        },

        setup(props) {
            const form = useForm({
                _method: props.method || 'PUT',
                name: props.vertical?.name || null,
            });

            return {form}
        },
    }
</script>
